package com.milta.core.localization

/**
 * Strings for the OCR scan of a photographed paper delivery list — reading, review, correction,
 * failure/rate-limit states (contrat révisé DOM-02, `OcrScanScreen` / `OcrValidationScreen`).
 * Deliberately separate from [ImportsStrings] (MIL-29 Photo/PDF/Excel import) — different backend
 * endpoint, different flow (no session, no attempt limit).
 */
data class OcrScanStrings(
    val scanTitle: String,
    val reviewTitle: String,
    val fileSentSuffix: String,
    // ── Écran B — lecture de la photo ──
    val analysingTitle: String,
    val analysingSubtitle: String,
    // ── Écran C — vérifier les données ──
    val deliveriesDetectedSuffix: String,
    val toCompleteSuffix: String,
    val reviewHint: String,
    val addressMissingWarning: String,
    val nameMissingWarning: String,
    val recipientMissingPlaceholder: String,
    val phoneNotDetectedNote: String,
    val deadlineLabelPrefix: String,
    val completeLinkLabel: String,
    val addToRouteButtonPrefix: String,
    // ── Écran D — compléter une ligne ──
    val correctionRecipientLabel: String,
    val correctionAddressLabel: String,
    val correctionPhoneLabel: String,
    val correctionDeadlineLabel: String,
    // ── Écran E — photo illisible, nouvelle tentative possible ──
    val unreadableTitle: String,
    val unreadableMessage: String,
    val retakePhotoButton: String,
    val manualEntryButton: String,
    // ── Écran G — limite de fréquence atteinte (429) ──
    val rateLimitTitle: String,
    val rateLimitMessage: String,
    val rateLimitRetakeUnavailableLabel: String,
)
